import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { loadHelpWidget, platformExchange } from "@/lib/platform";

loadHelpWidget();

const root = ReactDOM.createRoot(document.getElementById("root"));
// A launch from the Heda platform signs in first, so the auth check below
// already sees the session.
platformExchange().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
